export interface UserProfile {
  ssoUserID: string;
  countryCode: string;
  givenName: string;
  lastName: string;
  locale: string;
  timeZone: string;
  email: string;
  organization: object;
  roles: Array<string>;
  userID: string;
  correlationID: string;
  loading: boolean;
}
